import React, { Component } from 'react';
import { StyleSheet, Text, View, Platform } from 'react-native';
import { Screen, Button, Input } from '../components';
import UserController from '../controllers/userController';
import ConsultationController from '../controllers/consultationController';
import { StringUtils, ArrayUtils } from '../utils';
import AsyncStorage from '@react-native-async-storage/async-storage';
import { useNavigate } from 'react-router-dom';

class SettingsChangePaymentScreen_Base extends Component {

  constructor(props) {
    super(props);
    this.state = {

    }

    this.updatePayment = this.updatePayment.bind(this);
    this.getCCInfo = this.getCCInfo.bind(this);
  }

  async componentDidMount() {
    let partner_id   = await AsyncStorage.getItem('partner_id');
    let subscription = await ConsultationController.getSubscriptionConsultation({ partner_id: partner_id });

    this.setState({
      partner_id
    })
  }

  async updatePayment() {
    this.setState({loading: true}, async () => {
      let cc_info = this.getCCInfo();
      let cc_exp_tokens = cc_info.cc_exp.split('/');

      cc_info = {
        cc_holder_name: cc_info.cc_holder_name,
        cc_num: cc_info.cc_number,
        cc_exp_month: cc_exp_tokens[0],
        cc_exp_year: cc_exp_tokens[1],
        cc_cvc: cc_info.cc_cvc,
        billing_zipcode: cc_info.cc_zipcode,
        partner_id: this.state.partner_id
      }

      console.log('cc_info', cc_info);

      if(ArrayUtils.allKeysNotNull(cc_info)) {
        console.log('getting here')
        let response = await UserController.updatePaymentMethod(cc_info);

        if(response.success) {
          this.goBack();
        } else {
          this.setState({
            loading: false,
            subscription_error: response.error
          })
        }
      } else {
        this.setState({
          loading: false,
          subscription_error: "All fields are required."
        })
      }
    });
  }

  goBack = () => {
    if(Platform.OS === 'web') {
      this.props.navigate(-1);
    } else {
      this.props.navigation.goBack();
    }
  }

  getCCInfo() {
    let cc_zipcode = this.state.cc_zipcode,
    cc_exp = this.state.cc_exp,
    cc_number = this.state.cc_number,
    cc_holder_name = this.state.cc_holder_name;

    let cc_info = {
      cc_holder_name,
      cc_number,
      cc_exp,
      cc_cvc: this.state.cc_cvc,
      cc_zipcode
    }

    return cc_info;
  }

  validateForm() {
    let cc_info = this.getCCInfo();

    let valid = ArrayUtils.allKeysNotNull(cc_info);

    if(valid && cc_info.cc_exp) {
      valid = StringUtils.validateExpirationDate(cc_info.cc_exp);
    }

    if(valid && cc_info.cc_zipcode) {
      valid = cc_info.cc_zipcode.length === 5;
    }

    return valid;
  }

  update_field(name, value) {
    this.setState({
      [name]: value
    }, () => {
      this.setState({
        form_valid: this.validateForm()
      })
    });
  }

  update_expiration_field = (expiration_date_str) => {
    let new_string = expiration_date_str;
        new_string = new_string.replace('/', '');

    if (new_string.length === 3) {
      new_string = new_string[0] + new_string[1]  + '/' + new_string[2];
    } else if (new_string.length >= 4) {
      new_string = new_string[0] + new_string[1]  + '/' + new_string[2] + new_string[3];
    }

    this.setState({ cc_exp: new_string })
  }

  render_inputs_section = () => {

    return <View style={{ padding: 20, paddingBottom: 0 }}>
       <Input label={ 'Card Holder Name' }
              style={{ marginBottom: 10 }}
              onChangeText={ (cc_holder_name) => { this.update_field('cc_holder_name', cc_holder_name)}} />

       <Input label={ 'Credit Card Number' }
              style={{ marginBottom: 10 }}
              keyboardType='number-pad'
              onChangeText={ (cc_number) => { this.update_field('cc_number', cc_number)}} />

       <Input label={ 'Expiration MM/YY' }
              value={this.state.cc_exp}
              style={{ marginBottom: 10 }}
              placeholder='MM / YY'
              onChangeText={ (cc_exp) => { this.update_expiration_field(cc_exp) }} />

        <Input label={ 'CVV' }
               style={{ marginBottom: 10 }}
               keyboardType='number-pad'
               onChangeText={ (cc_cvc) => { this.update_field('cc_cvc', cc_cvc)}} />

        <Input label={ 'Zipcode' }
               style={{ marginBottom: 10 }}
               keyboardType='number-pad'
               onChangeText={ (cc_zipcode) => { this.update_field('cc_zipcode', cc_zipcode)}} />
    </View>
  }

  render_payment_button = () => {

    let valid = this.state.form_valid;
    let loading = this.state.loading;
    let subscription_error = this.state.subscription_error;

    return <View style={{ alignItems: 'center' }}>
      {subscription_error ? <Text style={styles.error_message}>{subscription_error}</Text> : null}
      <Button title='Update Payment Method'
              inactive={!valid}
              loading={loading}
              style={{ width: 335, marginBottom: 10, marginTop: 15 }}
              onPress={this.updatePayment}/>
    </View>
  }


  render() {
    //let keyboard_vertical_offset = Platform.OS === 'ios' ? 10 : 0;

    return (
      <Screen navigation={this.props.navigation} title={`Change Payment Method`} bg_white={true} scroll={true}>
        { this.render_inputs_section()  }
        { this.render_payment_button() }
      </Screen>
    );
  }

}

function SettingsChangePaymentScreen(props) {
  if(Platform.OS === 'web') {
    const navigate = useNavigate();

    return  <SettingsChangePaymentScreen_Base {...props} navigate={navigate} />
  } else {
    return  <SettingsChangePaymentScreen_Base {...props} navigate={props.navigation.push} />
  }
}

const styles = StyleSheet.create({
  content_container: {
    backgroundColor: 'white',
    borderRadius: 15,
    borderWidth: 1,
    borderColor: '#e7e7e7',
    padding: 20,
  },
  main_container: {
    flex: 1,
    padding: 20,
  },
  error_message: {
    color: 'red'
  }
});

export default SettingsChangePaymentScreen
